<template>

    <div id="about">
        <section class="welcome">
            <div class="start">
                <h1>
                    <span>О&nbsp;компании</span>
                </h1>
                <div class="text">Группа компаний &laquo;Ренна&raquo;&nbsp;&mdash; это признанный лидер по&nbsp;производству молочных консервов и&nbsp;мороженого в&nbsp;России, также компания занимает ведущие позиции на&nbsp;рынке цельномолочной продукции юга страны.
                </div>
                
                <div class="list">
                    <ul>
                        <li>
                            <div class="row">
                                <div class="merits">20&nbsp;лет</div>
                                <span>Торгово-производственный холдинг успешно реализует свою продукцию высокого качества уже более 20&nbsp;лет.</span>
                            </div>
                        </li>
                        <li>
                            <div class="row">
                                <div class="merits">50&nbsp;000</div>
                                <span>В&nbsp;более 50&nbsp;000 торговых точек присутствует продукция компании во&nbsp;всех регионах России от&nbsp;Калининграда до&nbsp;Владивостока.</span>
                            </div>
                        </li>
                        <li>
                            <div class="row">
                                <div class="merits">30&nbsp;стран</div>
                                <span>Продукция компании представлена в&nbsp;30&nbsp;странах ближнего и&nbsp;дальнего зарубежья, включая США и&nbsp;страны&nbsp;ЕС.</span>
                            </div>
                        </li>
                        <li>
                            <div class="row">
                                <div class="merits">300</div>
                                <span>Более 300 наименований натуральной молочной продукции собственного производства завоевали любовь потребителей всех возрастов во&nbsp;многих странах мира. Многие из&nbsp;этих продуктов стали поистине народными марками.</span>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="title">Наша миссия</div>
                
                <div class="textmission">Cоздавать вкусные молочные продукты для&nbsp;жизни и&nbsp;наслаждения.</div>
<!--
<div class="textmission">Cоздавать вкусные молочные продукты для&nbsp;жизни и&nbsp;наслаждения с&nbsp;заботой о&nbsp;потребителях, ответственностью перед партнерами и&nbsp;вниманием к&nbsp;окружающей среде.</div>
-->

                <div class="image1">
                    <div class="x1"><img src="img/about/img23.png" alt=""></div>
                    <div class="x2"><img src="img/about/img23@2x.png" alt=""></div>
                </div>
<!--
                <div class="title">Наши ценности</div>
                <div class="listing">
                    <ul>
                        <li>
                            <div class = "assets">
                                &#10052;&nbsp;<span>Забота о потребителях</span>
                            </div>    
                        </li>
                    <li>
                        <div class = "assets">
                            &#10052;&nbsp;
                            <span>Стремление к совершенству</span>
                        </div>
                    </li>
                    <li>
                        <div class = "assets">
                            &#10052;&nbsp;
                            <span>Сохранение традиций качества</span>
                        </div>
                    </li>
                    <li>
                        <div class = "assets">
                            &#10052;&nbsp;
                            <span>Профессионализм</span>
                        </div>
                    </li>
                    <li>
                        <div class = "assets">
                            &#10052;&nbsp;
                            <span>Командная работа</span>
                        </div>
                    </li>
                    <li>
                        <div class = "assets">
                            &#10052;&nbsp;
                            <span>Ответственность перед будущими поколениями</span>
                        </div>
                    </li>
                    </ul>
                </div>
-->


                <div class="title">Наши ценности</div>
                <div class="listing">
                    <ul>
                        <li>
                            <div class = "assets">
                                &#10052;&nbsp;<span>Любовь и гордость за продукт</span>
                            </div>    
                        </li>
                    <li>
                        <div class = "assets">
                            &#10052;&nbsp;
                            <span>Хорошее настроение</span>
                        </div>
                    </li>
                    <li>
                        <div class = "assets">
                            &#10052;&nbsp;
                            <span>Уважение к сотрудникам</span>
                        </div>
                    </li>
                    <li>
                        <div class = "assets">
                            &#10052;&nbsp;
                            <span>Постоянное развитие</span>
                        </div>
                    </li>
                    <li>
                        <div class = "assets">
                            &#10052;&nbsp;
                            <span>Партнерство</span>
                        </div>
                    </li>
                    
                    </ul>
                </div>


            </div>
        </section>

        <section class="catalog">
        
            <div class="product">
                <div class="row">
                    <div class="left">
                        <div class="image2">
                            <div class="x1"><img src="img/about/img24.png" alt=""></div>
                            <div class="x2"><img src="img/about/img24@2x.png" alt=""></div>
                        </div>
                        <div class="title">От&nbsp;молока <br>до&nbsp;мороженого</div>
                        <div class="text">Продукция ГК&nbsp;&laquo;Ренна&raquo; имеет заслуженное признание и&nbsp;всенародную любовь. 
                        На&nbsp;современных фабриках компании выпускаются такие бренды, как&nbsp;&laquo;Коровка из&nbsp;Кореновки&raquo; 
                        и&nbsp;&laquo;Алексеевское&raquo;, а&nbsp;также торговые марки &laquo;Облака из&nbsp;молока&raquo;, &laquo;Руслада&raquo;, 
                        &laquo;Густияр&raquo;, &laquo;Кореновское&raquo; и&nbsp;&laquo;Милкимоны&raquo;.
                        </div>  
                    </div>
                    <div class="right">
                        <div class="logo1"></div>
                    </div>
                </div>
<!--                
                <div class="column">
                     <div class="column-text">Сейчас на&nbsp;полках российских магазинов можно найти цельномолочную продукцию, молочные лакомства, десятки видов мороженого, готовые решения: печеные творожники &laquo;Чизби&raquo;, &laquo;Кубанские творожники&raquo; и&nbsp;другие продукты, выпускаемые группой компаний &laquo;Ренна&raquo;.</div>
                </div>
-->

                <div class="subtitle">Ассортимент продукции холдинга постоянно расширяется</div>
                <p>Широкий ассортимент регулярно пополняется новинками, созданными с&nbsp;заботой о&nbsp;каждом покупателе: на&nbsp;любой вкус, объем и&nbsp;по&nbsp;разумным ценам.</p>

                <div class="subtitle">С заботой о будущем</div>
                <p>Социальная ответственность&nbsp;&mdash; одна из важнейших составляющих деятельности холдинга. В разработке и реализации своей бизнес-стратегии ГК&nbsp;&laquo;Ренна&raquo; ориентируется на цели устойчивого развития ООН.</p>
            </div>
        </section>

        <section class="show">
            <div class="show-content">
                <div class="title">Ближе, <span>чем кажется</span></div>
                <p>Современное высокотехнологичное производство Группы компаний &laquo;Ренна&raquo; представлено предприятиями, каждое из которых имеет свою историю и&nbsp;традиции.</p>
                <div class="list">
                    <ul>
                        <li>
                            <div class="item">
                                <div class="img1" onclick="location.href='https://kizk.ru';"></div>
                                <div class="subtitle">Кореновский</div>
                                <p>молочно-консервный комбинат, <br>основан в&nbsp;1952&nbsp;году</p>
                            </div>
                        </li>
                        <li>
                            <div class="item">
                                <div class="img2" onclick="location.href='https://amkk.ru';"></div>
                                <div class="subtitle">Алексеевский</div>
                                <p>молочноконсервный комбинат, <br>основан в&nbsp;1960&nbsp;году</p>
                            </div>
                        </li>
                    </ul>

                    
                    <div class="inneritem">
                        <div class="img3" onclick="location.href='https://kizk.ru';"></div>
                        <p>В&nbsp;2014&nbsp;году на&nbsp;базе Кореновского <br>молочно-консервного комбината появилась</p>
                        <div class="subtitle">Фабрика настоящего мороженого</div>
                    </div>
                    

                    <ul>
                        <li>
                            <div class="item">
                                <div class="img4" onclick="location.href='https://kizk.ru';"></div>
                                <div class="subtitle">Фабрика </div>
                                <div class="subtitle2">настоящих молочных продуктов </div>
                                <p>основана в&nbsp;2020&nbsp;году</p>
                            </div>
                        </li>
                        <li>
                            <div class="item" onclick="location.href='https://amkk.ru';">
                                <div class="img5"></div>
                                <div class="subtitle">Фабрика</div>
                                <div class="subtitle2">сгущенного молока</div>
                                <p>основана в&nbsp;2020&nbsp;году</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="sbyt">    
                    <div class="distribution">Дистрибуция</br>и&nbsp;реализация</br>готовой продукции</div>
                    <div class="text">Свою продукцию холдинг успешно реализует, используя торговые, сетевые и логистические возможности компаний &laquo;Торговый дом Ренна&raquo;, &laquo;Ренна&#8211;Дистрибуция&raquo; и&nbsp;&laquo;Ренна&#8211;Логистик&raquo;, действующих на&nbsp;территории Российской Федерации и&nbsp;за&nbsp;ее&nbsp;пределами. Благодаря этому натуральные продукты высокого качества под товарными знаками ГК&nbsp;&laquo;Ренна&raquo; можно найти и&nbsp;на&nbsp;прилавках крупных торговых сетей, и&nbsp;в&nbsp;небольших розничных магазинах.
                    </div>
                    <div class="sbe">
                        <div class="header3">Торговый дом Ренна</div>
                        <div class="img28"></div>
                        <div class ="text">
                            &laquo;ТД Ренна&raquo; эксклюзивно отвечает за&nbsp;дистрибуцию и&nbsp;продажу продукции торговых марок ГК&nbsp;&laquo;Ренна&raquo;. Наши партнеры&nbsp;&mdash; крупнейшие федеральные сети страны, а&nbsp;также дистрибуторы стран ближнего и&nbsp;дальнего зарубежья.
                        </div>
                        <div class="counter">
                            <ul>
                                <div class="row">
                                    <li>
                                        <span class="name">
                                            Поставки
                                        </span>
                                    </li>

                                    <li>
                                        <div class="img31"></div>                             
                                        <div class="line">
                                            <span>250</span>
                                            <i>партнеров-дистрибуторов</i>
                                        </div>
                                    </li>
                                </div>
                                <div class=row>    
                                    <li>
                                        <span class="name">Экспорт</span>
                                    </li>
                                    <li>
                                        <div class="img32"></div>                               
                                        <div class="line">
                                            <span>50</span>
                                            <i>дистрибуторов-импортеров</i>
                                        </div
                                    </li>
                                </div>
                                <div class=row>
                                    <li>
                                        <span class="name">Страны</span>
                                    </li>
                                    <li>
                                        <div class="img33"></div>
                                        <div class="line">
                                            <span>30</span>
                                            <i>стран присутствия продукции</i>
                                        </div>
                                    </li>
                                </div>
                            </ul>
                        </div>
                        <div class="stroke"></div>     
                    </div>
                    <div class="sbe">
                        <div class="header3">Ренна&#8211;Дистрибуция</div>
                        <div class="img29" onclick="location.href='http://distribution.rennagroup.ru';"></div>
                        <div class ="text">
                            &laquo;Ренна&#8211;Дистрибуция&raquo; объединяет сеть дистрибуторских компаний &laquo;Лидер&raquo;, действующих на территории Российской Федерации. Мы&nbsp;обслуживаем множество торговых точек, из&nbsp;которых 60% посещаются на&nbsp;ежедневной основе. Собственный автопарк компании и&nbsp;привлеченный наемный транспорт насчитывают сотни автомобилей с&nbsp;холодильными и&nbsp;морозильными установками. Складские мощности с&nbsp;низкотемпературными режимами хранения составляют тысячи квадратных метров.
                        </div>
                        <div class="counter">
                            <ul>
                                <div class="row">
                                    <li>
                                        <span class="name">
                                            Торговля
                                        </span>
                                    </li>

                                    <li>
                                        <div class="img34"></div>                             
                                        <div class="line">
                                            <span>13&nbsp;000</span>
                                            <i>торговых точек</i>
                                        </div>
                                    </li>
                                </div>
                                <div class=row>    
                                    <li>
                                        <span class="name">Автопарк</span>
                                    </li>
                                    <li>
                                        <div class="img35"></div>                               
                                        <div class="line">
                                            <span>500</span>
                                            <i>автомобилей с холодильными и морозильными установками</i>
                                        </div
                                    </li>
                                </div>
                                <div class=row>
                                    <li>
                                        <span class="name">Склады</span>
                                    </li>
                                    <li>
                                        <div class="img36"></div>
                                        <div class="line">
                                            <span>10&nbsp;000&nbsp;кв.м</span>
                                            <i>площадей с низкотемпературным режимом хранения</i>
                                        </div>
                                    </li>
                                </div>
                            </ul>
                        </div>
                        <div class="stroke"></div>     
                    </div>
                    <div class="sbe">
                        <div class="header3">Ренна&#8211;Логистик</div>
                        <div class="img30" onclick="location.href='http://logistics.rennagroup.ru';"></div>
                        <div class ="text">
                            Компания &laquo;Ренна&#8211;Логистик&raquo; организует и&nbsp;обеспечивает цепь поставок грузов 
                            ТД&nbsp;&laquo;Ренна&raquo; по&nbsp;всей территории страны, включая их сопровождение и&nbsp;хранение. Ежедневно мы&nbsp;отправляем 
                            рейсы транспортных средств с&nbsp;особыми требованиями к&nbsp;температуре, обеспечиваем полный комплекс услуг 
                            логистики 3PL и&nbsp;располагаем комплексом современных складов низкотемпературного ответственного 
                            хранения объемом до&nbsp;70&nbsp;000 паллет.
                        </div>
                        <div class="counter">
                            <ul>
                                <div class="row">
                                    <li>
                                        <span class="name">Доставка</span>
                                    </li>

                                    <li>
                                        <div class="img37"></div>                             
                                        <div class="line">
                                            <span>150</span>
                                            <i>рейсов ежедневно</i>
                                        </div>
                                    </li>
                                </div>
                                <div class=row>    
                                    <li>
                                        <span class="name">Логистика</span>
                                    </li>
                                    <li>
                                        <div class="img38"></div>                               
                                        <div class="line">
                                            <span>3PL</span>
                                            <i>полный комплекс услуг</i>
                                        </div
                                    </li>
                                </div>
                                <div class=row>
                                    <li>
                                        <span class="name">Хранение</span>
                                    </li>
                                    <li>
                                        <div class="img39"></div>
                                        <div class="line">
                                            <span>60</span>
                                            <i>складов низкотемпературного ответственного хранения</i>
                                        </div>
                                    </li>
                                </div>
                            </ul>
                        </div>
                        <div class="stroke"></div>     
                    </div>
                </div>

<!-- Удалено 09.09.21 по указанию ГД                

                <div class="retail">
                    <div class="business">Собственный</br>ритейл&#8211;бизнес</div>
                    <div class="text">В июле 2015&nbsp;года в&nbsp;самом центре Москвы&nbsp;&mdash; на&nbsp;Арбате открылся первый фирменный киоск мороженого &laquo;Коровка из&nbsp;Кореновки&raquo;. 
                    Сейчас их уже&nbsp;30! Ежегодно в&nbsp;наших киосках продается около одного миллиона порций мороженого.   
                    </div>
                    
                    <div class="report">
                        <div class="header3">2020&nbsp;год</div>
                        <div class="counter">
                            <ul>
                                <div class="row">
                                    <li><span class="name">Москва</span></li>
                                    <li>                              
                                        <div class="img"></div>
                                        <div class="line">
                                            <span>1&nbsp;000&nbsp;000</span>
                                            <i>порций мороженого</i>
                                        </div>
                                    </li>
                                </div>
                            </ul>
                        </div>
                        <div class="stroke"></div>    
                    </div>
                </div> 
-->

            </div>
        </section>

        <section class="team">
            <div class="bg"></div>
            <div class="company">    
                <div class="title">Команда</div>
                   
                <p>Гордость компании&nbsp;&mdash; команда высококлассных профессионалов, чьи умения и&nbsp;навыки помогают воплощать в&nbsp;жизнь самые смелые идеи. Почти 5000&nbsp;сотрудников, работающих в&nbsp;Группе компаний &laquo;Ренна&raquo;&nbsp;&mdash; это творческие, увлеченные люди, объединенные общей целью: производство и&nbsp;распространение продукции высокого качества для жизни и&nbsp;наслаждения.</p>
                
                <div class="team-report">
                    <div class = header3>5&nbsp;000 сотрудников</div>
                    <div class="row">
                        <div class="img"></div>
                        <div class="line"><i>Команда высококлассных профессионалов</i></div>
                    </div>
                    <div class="stroke"></div>
                </div>

                <div class="teamsecret">Секрет эффективной деятельности команды</div>
                <div class="anons">Ключевыми корпоративными ценностями являются: профессионализм, ориентация на&nbsp;клиента, лидерство и&nbsp;командная работа. Секрет эффективной деятельности команды&nbsp;&mdash; слаженная работа всех и&nbsp;персональная ответственность каждого за&nbsp;общий результат.</div>
                <div class="text">В&nbsp;компании всегда рады тем, кто искренне увлечен своей работой, и&nbsp;готов к&nbsp;профессиональному росту и&nbsp;развитию.</div>
                
            </div>
        </section>

        <section class="bottom"> 
            <div class="foot">
                <div class="title">Секрет успеха</div>
                <div class="anons">
                    <p>Основные принципы работы Группы компаний &laquo;Ренна&raquo;:</p>
                </div>
                <div class="list">
                    <ul>
                        <li>
                            <div class="item">
                                <div class="header3">Высшее<br> качество</div>
                                <div class="line">Молоко только высшего качества</div>
                            </div>
                        </li>
                        <li>
                            <div class="item">
                                <div class="header3">Собственное<br> производство</div>
                                <div class="line">Собственное производство, соединяющее высокие технологии и&nbsp;верность традициям</div>
                            </div>
                        </li>
                        <li>
                            <div class="item">
                                <div class="header3">Постоянное<br> развитие</div>
                                <div class="line">Постоянное развитие и&nbsp;поиск новых рецептов</div>
                            </div>
                        </li>
                        <li>
                            <div class="item">
                                <div class="header3">Более 60&nbsp;лет<br> экспертизы</div>
                                <div class="line">Более 60&nbsp;лет экспертизы молочных продуктов и&nbsp;бескомпромиссное отношение к&nbsp;качеству продукции</div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="text">
                    <p>Благодаря этой стратегии, холдинг год за&nbsp;годом удерживает лидирующие позиции на&nbsp;российском рынке производства и&nbsp;дистрибуции молочной продукции.</p>
                    <p>Внешний вид, вкус и&nbsp;качество продуктов ежедневно совершенствуются, создаются новые линейки, возрождаются старинные рецепты, осваиваются новые технологии производства&nbsp;&mdash; все это для того, чтобы вызвать одобрение самого строгого судьи, &laquo;своего&raquo; покупателя.</p>
                </div>
            
            </div>
        </section>    

<!--
        <div class="lenta">

            <news></news>

            <!--<div class="lenta-logo"></div>-->
        </div>
-->
    </div>
</template>

<script>
    export default {
        name: "Home"
    }
</script>